import { render, staticRenderFns } from "./AProductionBomTree.vue?vue&type=template&id=b3883d24&"
import script from "./AProductionBomTree.vue?vue&type=script&lang=js&"
export * from "./AProductionBomTree.vue?vue&type=script&lang=js&"
import style0 from "./AProductionBomTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports